var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_vm._v(" "),(_vm.column === _vm.selectedColumn)?[(_vm.sortDirection === 'asc')?_c('i',{staticClass:"fa fa-sort-amount-asc",attrs:{"aria-hidden":"true"}}):_c('i',{staticClass:"fa fa-sort-amount-desc",attrs:{"aria-hidden":"true"}})]:[_c('i',{staticClass:"fa fa-sort",attrs:{"aria-hidden":"true"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }